import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { checkCloseTutorial } from "../../../features/mobile/otherSlice";

const Tutorial = ({ setTutorialState }) => {
  const { t } = useTranslation();
  const { loginInfo } = useSelector((state) => state.commonApp);
  const { questionsCompleteCheck } = useSelector((state) => state.others);
  const navigate = useNavigate();

  // const [status, setStatus] = useState(1);
  const dispatch = useDispatch();

  // useEffect(() => {
  //       dispatch(checkCloseTutorial(loginInfo.userId));
  // }, [status, dispatch, loginInfo.userId, navigate]);

  // const onChangeExplain = (e) => {
  //   if (e.target.checked) dispatch(checkCloseTutorial(loginInfo.userId));
  // };
  const onCloseGuide = async () => {
    try {
      const res = await dispatch(checkCloseTutorial(loginInfo.userId)).unwrap();

      if (res) {
        setTutorialState(false);
        window.location.reload();
      } else {
        console.log(t('tutorial.close_guide_failed'));
      }
    } catch (error) {
      console.error(t('tutorial.close_guide_error'), error);
    }
  };

  return (
    <div className="h-auto w-full rounded-tl-[28px] bg-back_ground px-[11px] pb-[100px] ">
      <div className="flex flex-col pt-[30px]">
        {/* <div className="fixed z-10 flex items-center mx-auto text-white maxW bottom-24 right-4 text-body1_600 gap-x-2">
        <span>Don't show this again</span>
        <input
          type="checkbox"
          className="tutorial"
          onChange={onChangeExplain}
        />
      </div> */}

        {/* Meal Record */}
        <div className="py-2.5">
          <div className="absolute flex flex-row px-2.5 overflow-hidden max-h-[180px]">
            <div className=" flex w-[180px] flex-col items-start gap-2">
              <p className="text-xl font-bold text-black">{t('tutorial.meal_record')}</p>
              <span className="text-[15px] font-medium leading-[18px] text-neutral-500">
                {t('tutorial.meal_record_desc')}
              </span>
              <button
                className="w-[107px] justify-center gap-2.5 rounded-3xl bg-main p-2.5"
                onClick={() => {
                  if (questionsCompleteCheck?.healthComplete) {
                    navigate("/meal/record");
                  } else {
                    navigate("/question/health");
                  }
                }}
              >
                <span className="text-base font-semibold leading-[18px] tracking-tight text-white">
                  {t('tutorial.record_button')}
                </span>
              </button>
            </div>
            <div className="flex items-end justify-center max-w-[180px] h-[180px] overflow-hidden">
              <img
                src="/images/mobile/home/guide_meal.svg"
                alt="meal record guide"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
          <div className="grid grid-cols-2 items-start gap-2.5 pb-2.5 pt-[180px]">
            {/* Weight Record */}
            <div
              className="flex w-full items-start gap-2.5"
              onClick={() => {
                if (questionsCompleteCheck?.healthComplete) {
                  navigate("/weight/record");
                } else {
                  navigate("/question/health");
                }
              }}
            >
              <div className="flex h-[218px] w-full flex-col items-start overflow-hidden rounded-xl border bg-white px-4 py-2.5">
                <div className="flex flex-col items-start w-full gap-2">
                  <div className="text-xl font-bold text-black">{t('tutorial.weight_record')}</div>

                  <div className="text-sm font-medium text-neutral-500">
                    {t('tutorial.weight_record_desc')}
                  </div>
                  <div className="flex items-end justify-center w-full h-[120px] overflow-hidden">
                    <img
                      src="/images/mobile/home/guide_weight.svg"
                      alt="weight record guide"
                      className="w-full h-full object-contain"
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* Symptom Record */}
            <div
              className="flex w-full items-start gap-2.5"
              onClick={() => {
                if (questionsCompleteCheck?.healthComplete) {
                  navigate("/symptom/record");
                } else {
                  navigate("/question/health");
                }
              }}
            >
              <div className="flex h-[218px]  w-full flex-col items-start overflow-hidden rounded-xl border bg-white px-4 py-2.5">
                <div className="flex flex-col items-start w-full gap-2">
                  <div className="text-xl font-bold text-black">{t('tutorial.symptom_record')}</div>

                  <div className="text-sm font-medium text-neutral-500">
                    {t('tutorial.symptom_record_desc')}
                  </div>
                  <div className="flex items-end justify-center w-full h-[120px] overflow-hidden">
                    <img
                      src="/images/mobile/home/guide_symptom.svg"
                      alt="symptom record guide"
                      className="w-full h-full object-contain"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 items-start gap-2.5 pb-5">
            {/* Steps */}
            <div
              className="flex w-full items-start gap-2.5"
              onClick={() => navigate("/step")}
            >
              <div className="flex h-[218px] w-full flex-col items-start justify-between overflow-hidden rounded-xl border bg-white">
                <div className="flex flex-col items-start gap-2 px-4 py-2.5">
                  <div className="text-xl font-bold text-black">{t('tutorial.steps')}</div>
                  <div className="text-sm font-medium text-neutral-500">
                    {t('tutorial.steps_desc')}
                  </div>
                </div>
                <div className="flex items-end justify-center w-full h-[130px] px-4 pb-2 overflow-hidden">
                  <img
                    src="/images/mobile/home/guide_step.svg"
                    alt="steps guide"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>
            {/* Medication Reminder */}
            <div
              className="flex w-full items-start gap-2.5"
              onClick={() => navigate("/drugalarm")}
            >
              <div className="flex h-[218px] w-full flex-col items-start justify-between overflow-hidden rounded-xl border bg-white">
                <div className="flex flex-col items-start gap-2 px-4 py-2.5">
                  <div className="text-xl font-bold text-black">{t('tutorial.medication_reminder')}</div>

                  <div className="text-sm font-medium text-neutral-500">
                    {t('tutorial.medication_reminder_desc')}
                  </div>
                </div>

                <div className="flex items-end justify-center w-full h-[130px] px-4 pb-2 overflow-hidden">
                  <img
                    src="/images/mobile/home/guide_drug.svg"
                    alt="medication reminder guide"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="pt-[10px]" onClick={() => navigate("/treatment")}>
            <div className="flex h-[109px] shrink-0 flex-row items-center justify-between gap-2.5 overflow-hidden rounded-xl border bg-white px-4 py-2">
              <div className="flex items-end justify-center flex-1 h-full overflow-hidden">
                <img
                  src="/images/mobile/home/guide_treatment.svg"
                  alt="appointment reminder guide"
                  className="w-full h-full object-contain"
                />
              </div>
              <div className="flex flex-col items-end gap-2 text-end flex-1">
                <p className="text-xl font-semibold text-black">
                  {t('tutorial.appointment_reminder')}
                </p>
                <span className="text-[15px] font-medium leading-[18px] text-neutral-500">
                  {t('tutorial.appointment_reminder_desc')}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-center w-full pt-4">
          <button
            className="flex h-[38px] items-center justify-center rounded-lg border border-main bg-white px-4 py-2"
            onClick={() => onCloseGuide()}
          >
            <span className="text-base font-medium leading-[18px] tracking-tight text-main">
              {t('tutorial.close_guide')}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Tutorial;
